export function changeLayout() {
    setLayoutFromCookie();
    var newLayout = this.getAttribute('data-layout');
    var targetElement = document.getElementById('product-list');
    if (targetElement){
        targetElement.setAttribute('layout', newLayout);
        setCookie('layout', newLayout, 7);
    }

    var gridButton = document.getElementById('grid-button');
    var rowButton = document.getElementById('row-button');

    if (newLayout === 'grid') {
        gridButton.style.display = 'none';
        rowButton.style.display = '';
    } else if (newLayout === 'row') {
        gridButton.style.display = '';
        rowButton.style.display = 'none';
    }
}

export function setLayoutFromCookie() {
     var cookie = getCookie('layout');
     if (cookie) {
        var targetElement = document.getElementById('product-list');
        targetElement.setAttribute('layout', cookie);
     }
}

var layoutTrigger = document.querySelectorAll('.layout-button');

layoutTrigger.forEach(element => {
    element.addEventListener('click', changeLayout);
});

/**
 * Set cookie
 *
 * @param {string} name
 * @param {any} value
 * @param {number} days
 * @param {boolean} encode
 */
export function setCookie(name,value,days, encode = false) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }

    if (encode) {
        value = btoa(value);
    }

    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

/**
 * Get cookie value by name
 *
 * @param {string} name
 * @param {boolean} isEncoded
 * @returns {string|null}
 */
export function getCookie(name, isEncoded = false) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0;i < ca.length;i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
            let val = c.substring(nameEQ.length,c.length);
            return isEncoded ? atob(val) : val;
        }
    }
    return null;
}